<footer class="footer">
  <div class="footer-container">
    <div class="footer-content">
      <div class="footer-logo-section">
        <img src="assets/full-logo-transparent.svg" alt="Hebern Logo" class="footer-logo" />
        <p class="footer-tagline">Quick and easy data encryption, secure from AI.</p>
      </div>
      <nav class="footer-nav">
        <ul class="footer-menu">
          @for (item of navItems; track item.path) {
          <li class="footer-item">
            <a [routerLink]="item.path" class="footer-link">
              {{ item.label }}
            </a>
          </li>
          }
        </ul>
      </nav>
    </div>
    <div class="footer-bottom">
      <p class="footer-copyright">
        &copy; {{ currentYear }} Hebern. All rights reserved.
      </p>
      <p class="footer-contact">
        Questions? <a href="mailto:support@hebern.com">support@hebern.com</a>
      </p>
    </div>
  </div>
</footer>
